import { gql } from 'urql';

const SubmitLineOfCreditAutoPayStatus = gql`
  mutation SubmitLineOfCreditAutoPayStatus(
    $idempotencyId: IdempotencyToken!
    $input: LineOfCreditUpdateAutoPayInput!
  ) {
    submitAutoPayForLineOfCredit(idempotencyId: $idempotencyId, input: $input) {
      ... on LineOfCreditUpdateAutoPaySuccess {
        isEnabled
      }
      ... on LineOfCreditUpdateAutoPayError {
        code
        message
        title
      }
    }
  }
`;

export default SubmitLineOfCreditAutoPayStatus;
